import { call, put, takeLatest } from "redux-saga/effects";
import { showToast } from "../../../components";

import {
  getAllPayrollStart,
  getAllPayrollSuccess,
  getAllPayrollFailure,
  getAllEmpPayConfigsStart,
  getAllEmpPayConfigsSuccess,
  getAllEmpPayConfigsFailure,
  addDeductionStart,
  addEmployeePayConfigure,
  addNewSalaryPayConfig,
  failureAddDeduction,
  failureGetAllDeductions,
  getAllEmpDeductions,
  getAllSalaryPayConfig,
  getAllSalaryPayConfigFailure,
  getAllSalaryPayConfigSuccess,
  getCurrentEmployeePayConfig,
  successAddDeduction,
  successCurrentEmployeePayConfig,
  successGetAllDeductions,
  addOtherPaymentsStart,
  failureOtherPaymentsStart,
  getAllEmpOtherPayments,
  successGetAllEmpOtherPayments,
  failureGetAlllEmpOtherPayments,
  updatePayrollStart,
  failUpdatePayroll,
  updatePayrollSuccess,
  updateOtherPaymentsStart,
  updateOtherPaymentsFailure,
} from "./payrollSlice";
import {
  addEmpDeductionApi,
  addEmpOtherPaymentsApi,
  addEmpPayConfigApi,
  addSalaryConfigApi,
  fetchAllSalaryProfileConfig,
  fetchEmpDeduction,
  fetchEmpOtherPayments,
  fetchEmpPayConfig,
  fetchPayrolls,
  updateEmpOtherPaymentsApi,
  updateEmpPayConfigApi,
  updatePayrollApi,
  updateSalaryConfigApi,
} from "./payrollApi";

function* getAllPayrollSaga(action) {
  try {
    const response = yield call(fetchPayrolls, action.payload);
    if (response.success) {
      yield put(getAllPayrollSuccess(response.data || {}));
    } else {
      yield put(getAllPayrollSuccess({}));
    }
  } catch (error) {
    yield put(getAllPayrollFailure(error));
    console.error("Placements fetch error:", error);
  }
}
function* getEmpPayConfigsSaga(action) {
  try {
    const response = yield call(fetchEmpPayConfig, action.payload);
    if (response.success) {
      yield put(getAllEmpPayConfigsSuccess(response.data || {}));
    } else {
      yield put(getAllEmpPayConfigsSuccess({}));
    }
  } catch (error) {
    yield put(getAllEmpPayConfigsFailure(error));
    console.error("Placements fetch error:", error);
  }
}

function* getAllSalaryPayConfigSaga(action) {
  try {
    const response = yield call(fetchAllSalaryProfileConfig, action.payload);
    if (response.success) {
      yield put(getAllSalaryPayConfigSuccess(response.data || {}));
    } else {
      yield put(getAllSalaryPayConfigSuccess({}));
    }
  } catch (error) {
    yield put(getAllSalaryPayConfigFailure(error));
    console.error("Placements fetch error:", error);
  }
}

function* addNewSalaryPayConfigSaga(action) {
  const { onSuccess, coll, payload, uiid, ...data } = action.payload;
  try {
    if (uiid) {
      const response = yield call(updateSalaryConfigApi, coll, payload, uiid);
      if (response.success) {
        if (onSuccess) {
          onSuccess();
          showToast("Salary configuration updated successfully", "success");
        }
      } else {
        yield put(getAllSalaryPayConfigFailure(response?.error));
      }
    } else {
      const response = yield call(addSalaryConfigApi, coll, payload);
      if (response.success) {
        if (onSuccess) {
          onSuccess();
          showToast("Salary configuration added successfully", "success");
        }
      } else {
        yield put(getAllSalaryPayConfigFailure(response?.error));
      }
    }
  } catch (error) {
    yield put(getAllSalaryPayConfigFailure(error));
    showToast("Failed to save salary configuration", "error");
    console.error("Placements fetch error:", error);
  }
}

function* getCurrentEmployeePayConfigSaga(action) {
  const { onSuccess } = action.payload;
  try {
    const response = yield call(fetchEmpPayConfig, action.payload);
    if (response.success) {
      if (onSuccess) {
        onSuccess(response.data);
      }
      yield put(successCurrentEmployeePayConfig(response.data || {}));
    } else {
      yield put(successCurrentEmployeePayConfig({}));
    }
  } catch (error) {
    yield put(getAllSalaryPayConfigFailure(error));
    console.error("Placements fetch error:", error);
  }
}
function* addEmployeePayConfigureSaga(action) {
  const { onSuccess, coll, payload, uiid, createPayroll, ...data } =
    action.payload;
  try {
    console.log("action.payload in add payconfig", action.payload);
    if (uiid) {
      const response = yield call(
        updateEmpPayConfigApi,
        coll,
        payload,
        uiid,
        createPayroll
      );
      if (response.success) {
        if (onSuccess) {
          onSuccess();
          showToast("Pay configuration updated successfully", "success");
        }
      } else {
        yield put(getAllSalaryPayConfigFailure(response?.error));
      }
    } else {
      const response = yield call(
        addEmpPayConfigApi,
        coll,
        payload,
        createPayroll
      );
      if (response.success) {
        if (onSuccess) {
          onSuccess();
          showToast("Pay configuration added successfully", "success");
        }
      } else {
        yield put(getAllSalaryPayConfigFailure(response?.error));
      }
    }
  } catch (error) {
    yield put(getAllSalaryPayConfigFailure(error));
    showToast("Failed to save pay configuration", "error");
    console.error("Placements fetch error:", error);
  }
}
function* addDeductionStartSaga(action) {
  const { onSuccess, payload } = action.payload;
  try {
    const response = yield call(addEmpDeductionApi, action.payload);
    if (response.success) {
      let type = payload.type === 2
          ? "Receive Payment"
            : payload.type === 3
      ? "Caution Amount" : "Deduction ";
      showToast(`${type} added successfully`, "success");
      if (onSuccess) {
        onSuccess();
        yield put(successAddDeduction());
      }
    } else {
      yield put(failureAddDeduction({}));
    }
  } catch (error) {
    yield put(failureAddDeduction(error));
    showToast("Failed to add deduction", "error");
    console.error("Placements fetch error:", error);
  }
}

function* getAllEmpDeductionsSaga(action) {
  try {
    const response = yield call(fetchEmpDeduction, action.payload);
    if (response.success) {
      yield put(successGetAllDeductions(response?.data || {}));
    } else {
      yield put(failureGetAllDeductions({}));
    }
  } catch (error) {
    yield put(failureGetAllDeductions(error));
    showToast("Unable to load deductions", "error");
    console.error("Placements fetch error:", error);
  }
}

function* addOtherPaymentsStartSaga(action) {
  const { onSuccess } = action.payload;
  try {
    const response = yield call(addEmpOtherPaymentsApi, action.payload);
    if (response.success) {
      if (onSuccess) {
        onSuccess(response);
        // yield put(successAddDeduction());
        showToast("Payment added successfully", "success");
        yield put(failureOtherPaymentsStart({}));
      }
    } else {
      yield put(failureOtherPaymentsStart({}));
    }
  } catch (error) {
    yield put(failureOtherPaymentsStart(error));
    showToast("Failed to add payment", "error");
  }
}

function* getAllEmpOtherPaymentsSaga(action) {
  try {
    const response = yield call(fetchEmpOtherPayments, action.payload);
    if (response.success) {
      yield put(successGetAllEmpOtherPayments(response?.data || {}));
    } else {
      yield put(successGetAllEmpOtherPayments({}));
    }
  } catch (error) {
    yield put(failureGetAlllEmpOtherPayments(error));
    showToast("Unable to load other payments", "error");
    console.error("Placements fetch error:", error);
  }
}
function* updatePayrollStartSaga(action) {
  const { onSuccess, customToast, ...data } = action.payload;
  try {
    const response = yield call(updatePayrollApi, data);
    if (response.success) {
      if (onSuccess) {
        onSuccess(response);
        yield put(updatePayrollSuccess({}));
        // yield put(successAddDeduction());
        showToast(customToast ? customToast : "Payroll updated successfully", "success");
      }
    } else {
      yield put(failUpdatePayroll({}));
    }
  } catch (error) {
    yield put(failUpdatePayroll(error));
    showToast("Failed to update payroll", "error");
  }
}
function* updateOtherPaymentsSaga(action) {
  const { onSuccess, ...data } = action.payload;
  try {
    const response = yield call(updateEmpOtherPaymentsApi, data);
    if (response.success) {
      if (onSuccess) {
        onSuccess(response);
        yield put(updateOtherPaymentsFailure(null));
        // yield put(successAddDeduction());
        showToast("Other payments updated successfully", "success");
      }
    } else {
      yield put(updateOtherPaymentsFailure(null));
    }
  } catch (error) {
    yield put(updateOtherPaymentsFailure(error));
    showToast("Failed to update other payments", "error");
  }
}
export function* watchFetchPayRoll() {
  yield takeLatest(getAllSalaryPayConfig.type, getAllSalaryPayConfigSaga);
  yield takeLatest(addNewSalaryPayConfig.type, addNewSalaryPayConfigSaga);
  yield takeLatest(
    getCurrentEmployeePayConfig.type,
    getCurrentEmployeePayConfigSaga
  );
  yield takeLatest(addEmployeePayConfigure.type, addEmployeePayConfigureSaga);
  yield takeLatest(addDeductionStart.type, addDeductionStartSaga);
  yield takeLatest(getAllEmpDeductions.type, getAllEmpDeductionsSaga);
  yield takeLatest(getAllEmpPayConfigsStart.type, getEmpPayConfigsSaga);
  yield takeLatest(addOtherPaymentsStart.type, addOtherPaymentsStartSaga);
  yield takeLatest(getAllEmpOtherPayments.type, getAllEmpOtherPaymentsSaga);
  yield takeLatest(getAllPayrollStart.type, getAllPayrollSaga);
  yield takeLatest(updatePayrollStart.type, updatePayrollStartSaga);
  yield takeLatest(updateOtherPaymentsStart.type, updateOtherPaymentsSaga);
}
